import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';

import VvnAboutAssitant from '../json-pages/VvnAboutAssitant';
import VvnBirds from '../json-pages/VvnBirds';
import VvnBoarding from '../json-pages/VvnBoarding';
import VvnBrachy from '../json-pages/VvnBrachy';
import VvnBreeding from '../json-pages/VvnBreeding';
import VvnDesexing from '../json-pages/VvnDesexing';
import VvnFeedingPet from '../json-pages/VvnFeedingPet';
import VvnFleas from '../json-pages/VvnFleas';
import VvnInsurance from '../json-pages/VvnInsurance';
import VvnPetInfo from '../json-pages/VvnPetInfo';
import VvnPrimaryDialog from '../json-pages/VvnPrimaryDialog';
import VvnProblems from '../json-pages/VvnProblems';
import VvnVaccinations from '../json-pages/VvnVaccinations';
import VvnFolder1 from '../json-pages/VvnFolder1';
import VvnFolder2 from '../json-pages/VvnFolder2';
import VvnFolder3 from '../json-pages/VvnFolder3';
import VvnFolder4 from '../json-pages/VvnFolder4';

const UI = ({ match }) => (
  <div className="dashboard-wrapper">
    <Switch>
      <Route
        path={`${match.url}/about-assistant`}
        component={VvnAboutAssitant}
      />
      <Route path={`${match.url}/birds`} component={VvnBirds} />
      <Route path={`${match.url}/boarding`} component={VvnBoarding} />
      <Route path={`${match.url}/brachy`} component={VvnBrachy} />
      <Route path={`${match.url}/breeding`} component={VvnBreeding} />
      <Route path={`${match.url}/desexing`} component={VvnDesexing} />
      <Route path={`${match.url}/feeding-pet`} component={VvnFeedingPet} />
      <Route path={`${match.url}/fleas`} component={VvnFleas} />
      <Route path={`${match.url}/insurance`} component={VvnInsurance} />
      <Route path={`${match.url}/pet-info`} component={VvnPetInfo} />
      <Route path={`${match.url}/primary`} component={VvnPrimaryDialog} />
      <Route path={`${match.url}/problems`} component={VvnProblems} />
      <Route path={`${match.url}/vaccinations`} component={VvnVaccinations} />
      <Route path={`${match.url}/folder1`} component={VvnFolder1} />
      <Route path={`${match.url}/folder2`} component={VvnFolder2} />
      <Route path={`${match.url}/folder3`} component={VvnFolder3} />
      <Route path={`${match.url}/folder4`} component={VvnFolder4} />

      <Redirect to="/error" />
    </Switch>
  </div>
);
export default UI;
